import classNames from "classnames";
import { isString } from "lodash-es";
import React, { ChangeEvent, FC } from "react";

import { ITestable, testAttr } from "@/browser";

import { positionClass } from "../../../Style";
import { IBlurable, IChangeable, IFocusable, IInputBasicProps, IStyleBasicProps } from "../types";
import { withFormElement } from "../withFormElement";

type TTextAreaResize = "both" | "horizontal" | "vertical" | "none";

export interface ITextareaProps
  extends IBlurable,
    IChangeable,
    IFocusable,
    IInputBasicProps,
    IStyleBasicProps,
    ITestable {
  rows?: number;
  resize?: TTextAreaResize;
}

const TextareaComponent: FC<ITextareaProps> = ({
  className,
  invalid,
  max,
  min,
  onChange,
  onBlur,
  onFocus,
  resize = "both",
  rows = 4,
  size = "md",
  touched,
  value,
  testName,
  testValue,
  ...rest
}) => {
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(event.target.value);
  };

  const handleBlur = () => {
    onBlur?.();
  };

  const handleFocus = () => {
    onFocus?.();
  };

  const wrapperClass = classNames(className, positionClass("relative"));
  const textClass = classNames("el-form-text", "el-form-textarea", {
    "el-form-text--not-valid": invalid,
    [`el-form-textarea--size-${size}`]: !!size,
    [`el-form-textarea--resize-${resize}`]: !!resize,
  });

  const stringValue = isString(value) ? value : "";

  return (
    <span className={wrapperClass}>
      <textarea
        className={textClass}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        value={stringValue}
        rows={rows}
        maxLength={max}
        minLength={min}
        {...testAttr({ testName, testValue }, { sufix: "textarea" })}
        {...rest}
      />
    </span>
  );
};

export const Textarea = withFormElement(TextareaComponent);
